export const contactsData = {
    email: 'ashraks97@gmail.com',
    phone: '0177668383833',
    address: 'Mymensingh, Dhaka, Bangladesh ',

    sheetAPI: 'https://sheetdb.io/api/v1/vbplcq2axr5s3'
}